import {
  type Category,
  type FilterPagedListQuery,
  type FilterSummary,
  type FilterType,
  type PagedList,
} from 'Types/beFiltersApi'
import { type LabelValuePair } from 'Types/common'
import { atom } from 'jotai'

const defaultEmptyPagedList = {
  Items: [],
  PageCount: 0,
  PageSize: 20,
  PageNumber: 1,
  TotalItems: 0,
}
export const filtersPagedListAtom = atom<PagedList<FilterSummary>>(
  defaultEmptyPagedList,
)

export const allCategoriesAtom = atom<Category[]>([])

export type SearchState = FilterPagedListQuery & {
  allTypes: boolean
  allCategories: boolean
}

export const defaultFiltersQuery: SearchState = {
  search: '',
  categories: [],
  types: [],
  allTypes: false,
  allCategories: false,
  orderBy: 'UpdateDate',
  orderDescending: true,
  pageNumber: 1,
  pageSize: 20,
}
export const filtersQueryAtom = atom<SearchState>(defaultFiltersQuery)

export const availFilterTypesAtom = atom<Array<LabelValuePair<FilterType>>>([])

export type ModalDeleteState =
  | {
      show: true
      idFilter: number
    }
  | { show: false }

export const modalDeleteAtom = atom<ModalDeleteState>({
  show: false,
})
